// ** React Imports
import { useState, Fragment } from 'react';

// ** Third Party Components
import { X, Trash } from 'react-feather';
import { useForm, Controller } from 'react-hook-form';
import SelectOptions from '@components/input/SelectOptions';

// ** Reactstrap Imports
import {
  Modal,
  ModalBody,
  Button,
  Form,
  Input,
  Label,
  FormFeedback
} from 'reactstrap';

// ** Utils
import { isObjEmpty, selectThemeColors } from '@utils';

// ** Styles Imports
import '@styles/react/libs/editor/editor.scss';
import '@styles/react/libs/flatpickr/flatpickr.scss';
import '@styles/react/libs/react-select/_react-select.scss';
import { handleConfirmCancel, handleError } from '@components/toast';

// ** Function to capitalize the first letter of string
const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);

// ** Modal Header
const ModalHeader = (props) => {
  // ** Props
  const {
    children,
    handleQuestionSidebar,
    setDeleted,
    deleted,
    selectedQuestion,
    deleteQuestion
    // deleteTask,
    // dispatch
  } = props;

  // ** Function to delete task
  const handleDelete = () => {
    handleConfirmCancel('delete', true, async () => {
      try {
        setDeleted(!deleted);
        deleteQuestion(selectedQuestion._id);
        handleQuestionSidebar();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  return (
    <div className="modal-header d-flex align-items-center justify-content-between mb-1">
      <h5 className="modal-title">{children}</h5>
      <div className="todo-item-action d-flex align-items-center">
        {!isObjEmpty(selectedQuestion) ? (
          <Trash
            className="cursor-pointer mt-25"
            size={16}
            onClick={() => handleDelete()}
          />
        ) : null}
        <span className="todo-item-favorite cursor-pointer mx-75"></span>
        <X
          className="fw-normal mt-25"
          size={16}
          onClick={handleQuestionSidebar}
        />
      </div>
    </div>
  );
};

const QuestionSidebar = (props) => {
  const [answers, setAnswers] = useState([]);
  // ** Props
  const {
    open,
    handleQuestionSidebar,
    handleAddQuestions,
    selectedQuestion,
    handleRemoveQuestion
  } = props;

  const [deleted, setDeleted] = useState(false);

  const {
    control,
    setError,
    setValue,
    clearErrors,
    handleSubmit,
    formState: { errors },
    watch
  } = useForm({
    defaultValues: { question: '', type: 'initial', answers: [] }
  });

  // ** Returns sidebar title
  const handleSidebarTitle = () => {
    return 'Agregar Pregunta';
  };

  // ** Function to run when sidebar opens
  const handleSidebarOpened = () => {
    if (!isObjEmpty(selectedQuestion)) {
      setValue('question', selectedQuestion.question);
      setValue('type', selectedQuestion.type);
      if (selectedQuestion?.answers?.length) {
        const answers = [];
        selectedQuestion.answers.map((tag) => {
          answers.push({ value: tag, label: capitalize(tag) });
        });
        setAnswers(answers);
      }
    }
  };

  // ** Function to run when sidebar closes
  const handleSidebarClosed = () => {
    setAnswers([]);
    setValue('question', '');
    setValue('type', 'initial');
    setValue('answers', []);
    // dispatch(selectTask({}));
    clearErrors();
  };

  // ** Renders Footer Buttons
  const renderFooterButtons = () => {
    if (!isObjEmpty(selectedQuestion)) {
      return (
        <Fragment>
          <Button color="primary" className="update-btn update-todo-item me-1">
            Actualizar
          </Button>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <Button color="primary" className="add-todo-item me-1">
            Agregar
          </Button>
          <Button color="secondary" onClick={handleQuestionSidebar} outline>
            Cancelar
          </Button>
        </Fragment>
      );
    }
  };

  const onSubmit = (data) => {
    const newQuestionAnswers = [];

    if (answers.length) {
      answers.map((tag) => newQuestionAnswers.push(tag.value));
    }
    const state = {
      _id: selectedQuestion._id,
      question: data.question,
      type: data.type,
      answers: newQuestionAnswers
    };
    if (data.type !== 'initial') {
      if (isObjEmpty(errors)) {
        if (
          isObjEmpty(selectedQuestion) ||
          (!isObjEmpty(selectedQuestion) && !selectedQuestion?.answers?.length)
        ) {
          handleAddQuestions([state]);
        } else {
          handleAddQuestions([state]);
        }
        handleQuestionSidebar();
      }
    } else {
      setError('type', {
        type: 'manual'
      });
    }
  };
  return (
    <Modal
      isOpen={open}
      toggle={handleQuestionSidebar}
      className="sidebar-lg"
      contentClassName="p-0"
      onOpened={handleSidebarOpened}
      onClosed={handleSidebarClosed}
      modalClassName="modal-slide-in sidebar-todo-modal"
    >
      <Form
        id="form-modal-todo"
        className="todo-modal"
        onSubmit={handleSubmit(onSubmit)}
      >
        <ModalHeader
          deleted={deleted}
          selectedQuestion={selectedQuestion}
          deleteQuestion={handleRemoveQuestion}
          setDeleted={setDeleted}
          handleQuestionSidebar={handleQuestionSidebar}
        >
          {handleSidebarTitle()}
        </ModalHeader>
        <ModalBody className="flex-grow-1 pb-sm-0 pb-3">
          <div className="mb-1">
            <Label htmlFor="question" className="label-road-input">
              Nombre de la pregunta
            </Label>
            <Controller
              id="question"
              name="question"
              control={control}
              render={({ field }) => (
                <Input
                  type="text"
                  placeholder="Nombre de la pregunta"
                  invalid={errors.question && true}
                  {...field}
                />
              )}
            />
            {errors.question && (
              <FormFeedback>Por favor ingrese una pregunta</FormFeedback>
            )}
          </div>
          <div className="mb-1">
            <Label htmlFor="type" className="label-road-input">
              Tipo de pregunta
            </Label>

            <Controller
              id="type"
              name="type"
              control={control}
              render={({ field }) => (
                <Input
                  type="select"
                  placeholder="Abierta / Cerrada"
                  invalid={errors.type && true}
                  {...field}
                >
                  <option disabled value="initial">
                    Abierta / Cerrada
                  </option>
                  <option value="open">Abierta</option>
                  <option value="close">Cerrada</option>
                </Input>
              )}
            />
          </div>
          {watch().type === 'close' && (
            <div className="mb-1">
              <Label className="form-label" for="task-tags">
                Opciones
              </Label>
              <SelectOptions
                theme={selectThemeColors}
                disabled={watch().type !== 'close'}
                options={answers}
                setOptions={setAnswers}
              />
            </div>
          )}

          <div>{renderFooterButtons()}</div>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default QuestionSidebar;
